export default __webpack_public_path__ + "static/media/VULNERAB_Dashboard.e82d691f.svg";